module.exports = __webpack_public_path__ + "static/media/ArzamasLogo.e86c9e2d.jpg";